import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Project from "../components/project";

import { projects } from "../content/projects.json";

const IndexPage = () => (
  <Layout currentPage="home">
    <SEO title="Home" />
    {projects.items.map(el => (
      <Project key={el.title} {...el} />
    ))}
  </Layout>
)

export default IndexPage
